module.exports = __webpack_public_path__ + "static/media/fbtb_thumb.49034325.png";